/* eslint-disable */
import React from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import Table, { TableActions, tableEditDelete } from 'partial/components/Table';
import { HiOutlineSearch } from 'react-icons/hi';
import { FaRegFileAlt } from 'react-icons/fa';
// import CountCard from 'partial/dashboard/CountCard';
import { useDebouceEffect } from 'partial/form/hooks';
import Pagination from 'partial/components/Pagination';
import FormInlineInput from 'partial/form/FormInlineInput';
import FormInlineSelect from 'partial/form/FormInlineSelect';
import { useActiveAccount } from 'modules/auth/hooks';
import Button from 'partial/components/Button';
import { useGetBillerOptions } from 'core-modules/users/hooks';
import { useDownloadFile } from 'partial/hooks';
import {
  // useCountCard,
  useTransactionList,
  useTransactionTotal,
} from '../hooks';

const MERCHANT_OPTIONS = [];

const DISABLE = false;

function Filter({ onSubmit, value, merchant }) {
  const [form, setForm] = React.useState(value);
  const [activeAccount] = useActiveAccount();
  const [merchantOptions] = useGetBillerOptions();
  useDebouceEffect(form.q, (q) => {
    onSubmit((state) => ({
      ...state,
      q,
    }));
  });
  const handleChange = (e) => (v) => {
    const val = v();
    setForm(v);
    onSubmit((state) => ({
      ...state,
      [e]: val[e],
    }));
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(form);
  };
  const handleClear = () => {
    setForm((state) => ({
      ...state,
      q: '',
    }));
    onSubmit((state) => ({
      ...state,
      q: '',
    }));
  };
  return (
    <form className="flex items-center justify-between" onSubmit={handleSubmit}>
      <div className="flex space-x-1">
        <div className="relative">
          <div className="w-72">
            <FormInlineInput
              name="q"
              onChange={setForm}
              value={form.q}
              placeholder="Search..."
              icon={HiOutlineSearch}
            />
          </div>
          {form.q ? (
            <button
              className="absolute top-0 right-0 py-2 px-3 font-semibold text-primary-500 hover:underline"
              type="button"
              onClick={handleClear}
            >
              Clear
            </button>
          ) : null}
        </div>
        {merchant && DISABLE ? (
          <div className="w-72">
            <FormInlineSelect
              name="merchant"
              onChange={handleChange('merchant')}
              value={form.merchant}
              label="Billers"
              placeholder="All Merchants"
              options={MERCHANT_OPTIONS}
            />
          </div>
        ) : null}
        {activeAccount?.role === 'organization' ? (
          <div className="w-72">
            <FormInlineSelect
              name="merchant_uuid"
              onChange={handleChange('merchant_uuid')}
              value={form.merchant_uuid || ''}
              label="Billers"
              options={[{ label: 'All', value: '' }, ...merchantOptions]}
            />
          </div>
        ) : null}
      </div>
      {/* <div className="inline-field flex space-x-1">
        date range filter
      </div> */}
      <Button onClick={handleSubmit} primary>
        Filter Selection
      </Button>
    </form>
  );
}

Filter.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  value: PropTypes.instanceOf(Object).isRequired,
  merchant: PropTypes.bool.isRequired,
  // channel: PropTypes.bool.isRequired,
};

function TransactionTable({
  filter: otherFilter,
  filterMerchant,
  filterChannel,
}) {
  const [raw, setFilter] = React.useState({
    q: '',
    merchant_uuid: '',
    channel: '',
    page: 1,
    // sort: 'created_at:desc',
  });
  const filter = React.useMemo(
    () => ({
      ...raw,
      ...otherFilter,
    }),
    [raw, otherFilter]
  );
  const match = useRouteMatch();
  const history = useHistory();
  const [isLoading, list, pager] = useTransactionList(filter);
  const [total] = useTransactionTotal(filter);
  const [activeAccount] = useActiveAccount();
  const [downloadFile, isDownloadFileLoading] = useDownloadFile({
    downloadUrl: `wallet/v1/merchant/transactions/export?q=${
      raw?.q || ''
    }&merchant_uuid=${raw?.merchant_uuid || ''}`,
    fileName: `TRANSACTIONS_LOGS${dayjs().format('DD/MM/YYYY')}`,
  });
  const tableFormat = React.useMemo(() => {
    const cols = [
      {
        label: 'Date',
        id: 'created_at',
        key: 'created_at',
        width: '190',
      },
      {
        label: 'Client Ref. NO.',
        id: 'client_refno',
        key: 'client_refno',
      },
      {
        label: 'Amount',
        id: 'amount',
        key: 'amount_human',
      },
      {
        label: 'Transaction Fee',
        id: 'transaction_fee',
        key: 'transaction_fee_human',
      },
      {
        label: 'Other Charges',
        id: 'other_charges',
        key: 'other_charges_human',
      },
      {
        label: 'Net Amount',
        id: 'net_amount',
        key: 'net_amount_human',
      },
      {
        label: 'Cashback Amount',
        key: 'cashback_amount_human',
      },
      {
        label: 'Payment Status',
        id: 'payment_status',
        key: (row) => (
          <p
            className={`capitalize ${
              get(row, 'payment_status') === 'SUCCESS'
                ? 'text-secondary-500'
                : 'text-danger-500'
            }`}
          >
            {get(row, 'payment_status')?.toLowerCase()}
          </p>
        ),
      },
      {
        label: 'Dispute Status',
        id: 'dispute_status',
        key: (row) => (
          <p
            className={
              row?.is_dispute ? 'text-secondary-500' : 'text-danger-500'
            }
          >
            {row?.is_dispute ? 'Success' : 'Failed'}
          </p>
        ),
      },
      {
        id: 'action',
        label: 'Action',
        key: (row) => (
          <TableActions
            onView={() => history.push(`${match.url}/view/${row?.uuid}`, row)}
            disputeDisabled={row?.is_dispute}
            disputeTooltip={
              row?.is_dispute
                ? 'This transaction has already been requested for a dispute'
                : undefined
            }
            onDispute={
              row?.payment_status === 'SUCCESS'
                ? () => history.push(`${match.url}/dispute/${row?.uuid}`, row)
                : null
            }
          />
        ),
      },
    ];
    if (activeAccount?.role === 'organization') {
      cols.splice(2, 0, {
        label: 'Billers',
        id: 'billers',
        key: 'biller_name',
      });
    }
    return cols;
  }, [activeAccount]);
  return (
    <div className="flex flex-col h-full">
      <div className="p-5">
        <Filter
          onSubmit={setFilter}
          value={raw}
          merchant={filterMerchant}
          channel={filterChannel}
        />
      </div>
      <div className="flex flex-1 border-b">
        <Table isLoading={isLoading} data={list} format={tableFormat} />
      </div>
      <div className="grid grid-cols-4 place-items-center w-full p-5">
        <div className="w-full pr-4 border-r">
          <Pagination small showPagesLabel onChange={setFilter} data={pager} />
        </div>
        <div className="w-full border-r">
          <p className="text-base text-center">
            Accumulated Transactions &nbsp;{' '}
            <span className="ml-auto text-primary-800 text-xl font-semibold">
              {total?.accumulated_transactions || '--'}
            </span>
          </p>
        </div>
        <div className="w-full px-2 border-r">
          <p className="text-base text-center">
            Accumulated Amount &nbsp;{' '}
            <span className="ml-auto text-primary-800 text-xl font-semibold">
              B${total?.accumulated_amount || '0.00'}
            </span>
          </p>
        </div>
        <div className="justify-self-center">
          <Button
            size="sm"
            outlinePrimary
            className="w-32 h-12"
            icon={FaRegFileAlt}
            onClick={downloadFile}
            isLoading={isDownloadFileLoading}
          >
            Export
          </Button>
        </div>
      </div>
    </div>
  );
}

TransactionTable.defaultProps = {
  filter: {},
  filterMerchant: true,
  filterChannel: true,
};

TransactionTable.propTypes = {
  filter: PropTypes.instanceOf(Object),
  filterMerchant: PropTypes.bool,
  filterChannel: PropTypes.bool,
};

export default TransactionTable;
